<mat-drawer-container [hasBackdrop]="tabletQuery.matches" class="page-height">
  <mat-drawer
    #drawer
    [mode]="tabletQuery.matches ? 'over' : 'side'"
    [position]="'end'"
    [opened]="!tabletQuery.matches"
    [disableClose]="!tabletQuery.matches"
  ></mat-drawer>
  <mat-drawer-content
    class="overflow-hidden ml-0 bg-panel page-height d-flex justify-content-between align-items-center flex-column p-md-2"
    >
    <!-- Settlements list header -->
    <mat-divider></mat-divider>
    <div
      class="d-flex justify-content-between align-items-center flex-row py-3 px-4 w-100 shadow main-panel rounded-md"
      style="z-index: 10"
      >
      <odin-settlements-toggle
        (updateSettlementSelection)="onChangeSettlementType($event)"
      ></odin-settlements-toggle>
    </div>

    <!-- Settlements list -->
    <div class="flex-fill w-100">
      @if (error$ | async; as error) {
        <div
          class="error-settlements"
          >
          {{ errorText('Unable to load settlements.', error) }}
        </div>
      } @else {
        @if (settlements$ | async; as settlements) {
          <div class="h-100" @fadeAnimation>
            @if (monthlySettlementSelected) {
              <odin-settlements-monthly-list
                (newMonthlySettlement)="onNewMonthlySettlementReport($event)"
                (newMonthlySettlementCSV)="onNewMonthlySettlementReportCSV($event)"
              ></odin-settlements-monthly-list>
            }
            @if (settlements.length > 0 && dailySettlementSelected) {
              <odin-settlements-list
                class="d-block h-100"
                [settlements]="settlements"
                [allowSelection]="allowSelection$ | async"
                [hasNext]="hasNext$ | async"
                [hasPrev]="hasPrev$ | async"
                [loading]="loading$ | async"
                (navigateToDetails)="navigateToDetails($event)"
                (scrollDirection)="loadSettlementsOnScroll($event)"
                >
                <!-- Lives inside the list so it scrolls with the rows and stays
                     within the panel instead of overflowing below it. -->
                @if (loading$ | async) {
                  <odin-loading-spinner
                    class="d-block py-3"
                    [active]="true"
                    [diameter]="40"
                    [colour]="colour"
                  ></odin-loading-spinner>
                }
                @if (noMoreToLoad$ | async) {
                    <div class="odin-list-end" data-test="settlements-list-end">
                      <mat-icon class="outline">check_circle</mat-icon>
                      <span>End of settlements</span>
                    </div>
                }
              </odin-settlements-list>
            }
            @if (settlements.length === 0 && (loading$ | async) === false) {
              <div class="odin-empty-state main-panel h-100" data-test="settlements-empty">
                <div class="odin-empty-state-icon">
                  <mat-icon class="outline">account_balance</mat-icon>
                </div>
                <p class="odin-empty-state-title">No settlements found</p>
                <p class="odin-empty-state-text">
                  There are no settlements for the selected period.
                </p>
              </div>
            }
            @if (settlements.length === 0 && dailySettlementSelected && (loading$ | async)) {
              <odin-loading-spinner
                class="mt-2"
                [active]="true"
                [diameter]="40"
                [colour]="colour"
              ></odin-loading-spinner>
            }
          </div>
        }
      }
    </div>
  </mat-drawer-content>
</mat-drawer-container>

